import { Component, OnInit, OnDestroy, ViewEncapsulation, inject } from '@angular/core';

import { Router, RouterOutlet, ActivatedRoute, NavigationEnd } from '@angular/router';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { HeaderComponent } from 'app/layout/common/header/header.component';
import { SecondaryHeaderComponent } from 'app/layout/common/secondary-header/secondary-header.component';
import { BottomNavigationComponent } from 'app/layout/layouts/mobile/ui/bottom-navigation/bottom-navigation.component';
import { AccountDrawerComponent } from 'app/layout/common/account-drawer/account-drawer.component';
import { HeaderStateService } from 'app/core/services/header-state.service';
import { Subject, filter, takeUntil } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'mobile-layout',
    standalone: true,
    imports: [
    RouterOutlet,
    FuseLoadingBarComponent,
    HeaderComponent,
    SecondaryHeaderComponent,
    BottomNavigationComponent,
    AccountDrawerComponent
],
    templateUrl: './mobile-layout.component.html',
    styleUrl: './mobile-layout.component.scss',
    encapsulation: ViewEncapsulation.None,
})
export class MobileLayoutComponent implements OnInit, OnDestroy {
    appVersion: string;

    readonly headerState = inject(HeaderStateService);

    private _router = inject(Router);
    private _activatedRoute = inject(ActivatedRoute);
    private _unsubscribeAll = new Subject<void>();

    ngOnInit(): void {
        this.appVersion = environment.version;

        // Set initial state (handles direct URL access / page refresh)
        this._updateHeaderState();

        // Update on every subsequent navigation
        this._router.events
            .pipe(
                filter(e => e instanceof NavigationEnd),
                takeUntil(this._unsubscribeAll),
            )
            .subscribe(() => this._updateHeaderState());
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    onMenuToggle(): void {
        console.log('Menu toggled');
    }

    // ---------------------------------------------------------------------------
    // Private
    // ---------------------------------------------------------------------------

    private _updateHeaderState(): void {
        const key = this._getDeepestData('headerTitle');
        this.headerState.set(key ?? null);
    }

    /** Traverse to the deepest activated child route and read a data property. */
    private _getDeepestData(key: string): string | undefined {
        let route = this._activatedRoute;
        while (route.firstChild) {
            route = route.firstChild;
        }
        return route.snapshot.data[key];
    }
}
